import _ from 'lodash';
import Q from 'q';

import GroupRoles from 'bundles/groups/constants/GroupRoles';
import GroupMembershipAPIUtils from 'bundles/groups/utils/GroupMembershipAPIUtils';

const _data = {}; // cache data

const groupMembershipsPromise = function (groupId: $TSFixMe, authenticated: $TSFixMe, isSuperuser: $TSFixMe) {
  if (!authenticated) {
    return Q({ canModerate: false });
  }

  if (isSuperuser) {
    return Q({ canModerate: true });
  }

  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (_data[groupId]) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return Q(_data[groupId]);
  }

  // otherwise check the membership promise
  return GroupMembershipAPIUtils.getMembershipForCurrentUser(groupId).then((response) => {
    const memberships = response.elements;
    const membershipForGroup = _.find(
      memberships,
      (membership) => membership.role === GroupRoles.GroupManager || membership.role === GroupRoles.DerivedGroupManager
    );

    let membership = { canModerate: false };
    if (membershipForGroup) {
      membership = { canModerate: true };
    }

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    _data[groupId] = membership;
    return membership;
  });
};

export default groupMembershipsPromise;
